<template>
    <v-card elevation="0" class="py-20px py-md-40px">
        <v-card-title class="tit tit--sm primary--text pt-0">
            <span>유의사항</span>
        </v-card-title>
        <v-card-text>
            <ul class="disc-list">
                <template v-for="(item, index) in items">
                    <li :key="index" v-html="item" />
                </template>
            </ul>
        </v-card-text>
    </v-card>
</template>

<script>
let items = `
교환권 번호 입력 후 충전된 나누리상품권의 유효기간은 교환일로부터 5년입니다.
교환된 내역은 ‘마이페이지 > 상품권 교환소 > 교환내역’에서 확인이 가능합니다.
교환 후 ‘선물하기’에서 수신자 정보 오기재 시 대한문고에서 책임지지 않습니다. 선물하기 전 꼭 재확인 바랍니다.
부정한 행위로 교환 및 충전 시도 시 서비스 이용에 제한이 있을 수 있습니다.
문의사항이 있을 경우 대한문고 고객센터(1800-9510) 또는 1:1문의, 채널톡으로 문의주시기 바랍니다. <br /> ※ 고객센터 운영시간 10:00~17:00 (주말 및 공휴일 휴무)
`
    .split("\n")
    .slice(1, -1);
export default {
    data: () => ({
        items,
    }),
};
</script>

<style lang="scss" scoped>
.disc-list {
    list-style: disc;
    padding-left: 16px;

    & > li::marker {
        font-size: 0.5em;
    }
}
</style>
